import { FetchError } from '../errors/FetchError'
import { fetchApi, fetchWithAuthorization } from './fetch'
import { fetchAllPages } from './pagination'

export const getUsers = async (page = 1, limit = 5, { role }) => {
  try {
    const data = await fetchWithAuthorization(`/users?role=${role}&page=${page}&limit=${limit}`)
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to get users')
  }
}

export const getConfigAsRoot = async () => {
  try {
    const data = await fetchAllPages((page, pageSize) =>
      fetchApi(`/public/price/all?page=${page}&limit=${pageSize}`)
    )
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createPriceRoot = async (min, max, price) => {
  try {
    const data = await fetchWithAuthorization('/condominium/price', { min, max, price }, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to save config')
  }
}

export const editPriceRoot = async (id, min, max, price) => {
  try {
    const data = await fetchWithAuthorization(`/condominium/price/${id}`, { min, max, price }, 'PUT')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http failed to save config')
  }
}
